import { useEffect } from "react";
import { matchPath, useLocation } from "react-router-dom";
import { setSentryOrganization } from "@/lib/sentry";

const ORGANIZATION_ROUTES = ["/club/:orgId/*", "/association/:orgId/*"];

/** Rattache les erreurs Sentry à l'organisation ouverte. Ne rend rien. */
export function SentryRouteContext() {
  const { pathname } = useLocation();

  useEffect(() => {
    for (const pattern of ORGANIZATION_ROUTES) {
      const orgId = matchPath(pattern, pathname)?.params.orgId;
      if (orgId) {
        setSentryOrganization(orgId);
        return;
      }
    }
  }, [pathname]);

  return null;
}
